import { createSelector } from '@ngrx/store';
import { IAuthState } from './auth.reducers';

// Using direct path instead of createFeatureSelector
export const selectAuthState = (state: any) => state['platform-auth'];

export const authSelectAuthenticated = createSelector(selectAuthState, (state: IAuthState) => state.authenticated);

export const authSelectAuthUsername = createSelector(selectAuthState, (state: IAuthState) => state.userName);

export const authSelectAuthUserEmail = createSelector(selectAuthState, (state: IAuthState) => state.email);

export const authSelectAuthLastAction = createSelector(selectAuthState, (state: IAuthState) => state.lastActionTime);

export const authSelectAnalyticData = createSelector(selectAuthState, (state: IAuthState) => {
    return { emailHash: state.emailHash ?? '', orgId: state.orgId ?? '', userType: state.userType, uiAnalytics: state.uiAnalytics };
});

export const authSelectOrganizationName = createSelector(selectAuthState, (state: IAuthState) => {
    return state.orgName;
});
